var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heatmap-sample",class:_vm.device})
}
var staticRenderFns = []

export { render, staticRenderFns }